module.exports = __webpack_public_path__ + "img/shoe-lace.e60bc127.png";